var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Header'),(_vm.dbUser)?_c('div',[(_vm.dbUser.roles.admin)?_c('div',[_c('NewMusicVideo')],1):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }